import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import { ArrowRight, Calendar } from 'lucide-react';

const Blog = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-50 to-gray-100 py-16 mb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-4">
            Blog
          </h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Güncel haberler, sektör trendleri ve ürün bilgileri hakkında yazılarımızı okuyun.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Featured Post */}
        {blogPosts.length > 0 && (
          <section className="mb-16">
            <Card className="overflow-hidden border-0 shadow-2xl rounded-none">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="relative h-96 md:h-auto">
                  <img
                    src={`${blogPosts[0].image}?w=800&q=80`}
                    alt={blogPosts[0].title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-[#E31E24] text-white px-4 py-2 rounded-full font-semibold">
                    Öne Çıkan
                  </div>
                </div>
                <CardContent className="p-8 md:p-12 flex flex-col justify-center">
                  <div className="flex items-center gap-2 text-gray-500 mb-4">
                    <Calendar className="w-5 h-5" />
                    <span>{blogPosts[0].date}</span>
                  </div>
                  <h2 className="text-3xl font-bold mb-4 hover:text-[#E31E24] transition-colors">
                    {blogPosts[0].title}
                  </h2>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    {blogPosts[0].excerpt}
                  </p>
                  <Link 
                    to={blogPosts[0].link} 
                    className="inline-flex items-center text-[#E31E24] font-semibold hover:gap-2 transition-all text-lg"
                  >
                    DEVAMINI OKU <ArrowRight className="w-5 h-5 ml-1" />
                  </Link>
                </CardContent>
              </div>
            </Card>
          </section>
        )}

        {/* All Posts Grid */}
        <section>
          <h2 className="text-3xl font-bold mb-8">Tüm Yazılar</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <Card key={post.id} className="group hover:shadow-2xl transition-all duration-300 overflow-hidden border-0 rounded-none">
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={`${post.image}?w=600&q=80`}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center gap-2 text-gray-500 mb-3 text-sm">
                    <Calendar className="w-4 h-4" />
                    <span>{post.date}</span>
                  </div>
                  <h3 className="text-xl font-bold mb-3 group-hover:text-[#E31E24] transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-3">{post.excerpt}</p>
                  <Link 
                    to={post.link} 
                    className="inline-flex items-center text-[#E31E24] font-semibold hover:gap-2 transition-all"
                  >
                    DEVAMINI OKU <ArrowRight className="w-4 h-4 ml-1" />
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Blog;
